module.exports = __webpack_public_path__ + "img/hic-cerebrovascular-disease-male.b457c82c.png";